import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  input,
  OnInit,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  ControlContainer,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ValidationErrorComponent } from '@shared/components/validation-error/validation-error.component';
import { controlContainerProvider } from '@shared/helpers';

export enum RadioFormType {
  Single = 'single',
  Double = 'double',
}

interface RadioFormConfig {
  type: RadioFormType;
  answerProperty?: string;
  subAnswerProperty?: string;
  subAnswerValues?: {
    yes: boolean;
    no: boolean;
  };
  validationTranslation?: {
    answer?: string;
    subAnswer?: string;
  };
  title: { question: string; subQuestion?: string };
}

@Component({
  selector: 'app-service-data-form-condition-history',
  imports: [TranslateModule, ValidationErrorComponent, ReactiveFormsModule],
  templateUrl: './service-data-form-condition-history.component.html',
  viewProviders: [controlContainerProvider],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceDataFormConditionHistoryComponent implements OnInit {
  private controlContainer = inject(ControlContainer);

  readonly config = input.required<RadioFormConfig>();
  readonly fieldSet = input.required<string[]>();
  readonly field = input.required<string>();

  protected get form() {
    return this.controlContainer.control as FormGroup;
  }

  protected RadioFormType = RadioFormType;

  private destroyRef = inject(DestroyRef);

  protected get answerProperty(): string {
    return this.config().answerProperty ?? 'hasReceived';
  }

  protected get subAnswerProperty(): string {
    return this.config().subAnswerProperty ?? 'isRelevant';
  }

  protected get subAnswerYesValue(): boolean {
    return this.config().subAnswerValues?.yes ?? false;
  }

  protected get subAnswerNoValue(): boolean {
    return this.config().subAnswerValues?.no ?? true;
  }

  ngOnInit(): void {
    if (this.config().type === RadioFormType.Double) {
      this.form
        .get(this.answerProperty)
        .valueChanges.pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((value: boolean) => {
          if (!value) {
            this.form.get(this.subAnswerProperty).reset(null);
          }
        });
    }
  }
}
